import { Cash } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCash12Line = createIcon(Cash, 12, "Line");
export const IconCash16Line = createIcon(Cash, 16, "Line");
export const IconCash20Line = createIcon(Cash, 20, "Line");
export const IconCash24Line = createIcon(Cash, 24, "Line");
export const IconCash32Line = createIcon(Cash, 32, "Line");
export const IconCash48Line = createIcon(Cash, 48, "Line");
export const IconCash64Line = createIcon(Cash, 64, "Line");
